import React from 'react';
import { Box } from '@mui/material';
import noDataImage from '@src/assets/images/no-data.svg';
import { StyledNoData } from './index.style';

const NoData = ({
  children,
  dropTable,
  useNewRequestUI,
  height,
  noDataText,
}) => (
  <Box width="100%" margin="auto">
    <StyledNoData useNewRequestUI={useNewRequestUI} height={height}>
      {children || (
        <img
          style={{ height: dropTable ? '86px' : 'auto' }}
          src={noDataImage}
          alt="no data"
        />
      )}
      {noDataText && <div className="no-data-text">{noDataText}</div>}
    </StyledNoData>
  </Box>
);

export default NoData;
